import React from "react";
import { Grid, Skeleton } from "@mui/material";
import { COLUMNS_CONSTANTS } from "bundles/Internal/components/company/CompanyTable";
import {
  formatCompanyCell,
  KeyValueTile,
} from "bundles/Internal/components/CompanyShowPage";

function CompanyDetailsTab({ company, loading }) {
  if (loading) {
    return (
      <Grid container spacing={3}>
        {[...Array(8)].map((_, idx) => (
          <Grid item xs={12} sm={6} key={idx}>
            <Skeleton variant="text" width="40%" />
            <Skeleton variant="text" width="60%" />
          </Grid>
        ))}
      </Grid>
    );
  }
  if (!company) return null;

  return (
    <Grid container spacing={3} alignItems="stretch">
      {COLUMNS_CONSTANTS.map((col) => {
        const value = formatCompanyCell(company, col.key);
        if (value === "" || value === null || value === undefined) return null;
        return (
          <Grid item xs={12} sm={6} key={col.key}>
            <KeyValueTile label={col.label} value={value} />
          </Grid>
        );
      })}
    </Grid>
  );
}

export default CompanyDetailsTab;
